import React, { useEffect, useState } from 'react';

import axios from 'axios';
import * as XLSX from 'xlsx';

type DataItem = {
  titular: string;
  cpf?: string;
  error: string;
  [key: string]: any;
};

type InclusaoErrosProps = {
  formData?: any;
  excelHeaders?: string[]; // Passe os headers originais aqui como prop!
  excelRawRows?: any[][]; // Passe TODAS as linhas originais aqui como prop!
};

export default function InclusaoErros({
  formData,
  excelHeaders,
  excelRawRows,
}: InclusaoErrosProps): JSX.Element {
  let message = '';
  const resultadoUnificado = formData?.responses.reduce(
    (acc, item) => {
      acc.data.push(...(item.data ?? []));
      acc.sucessos.push(...(item.RetornoApis?.sucessos ?? []));
      acc.erros.push(...(item.RetornoApis?.erros ?? []));
      acc.total += item.RetornoApis?.total ?? 0;
      acc.processados += item.RetornoApis?.processados ?? 0;
      return acc;
    },
    { data: [], sucessos: [], erros: [], total: 0, processados: 0, tipo: '' },
  );
  useEffect(() => {
    if (resultadoUnificado?.length > 0) {
      message =
        formData?.responses.find(x =>
          x.RetornoApis.find(x => x.erro.length > 0),
        ).RetornoApis?.message ||
        formData?.responses[0]?.message ||
        formData?.responses[0]?.RetornoApis[0]?.message;
    }
  }, [resultadoUnificado]);

  const downloadFailedRowsExcel = () => {
    if (
      !excelHeaders.length ||
      !excelRawRows.length ||
      !resultadoUnificado.erros.length
    ) {
      alert('Não há dados para exportar');
      return;
    }
    // Descobre o índice do CPF e Titular no excel
    const cpfIndex = excelHeaders.findIndex(h =>
      h.toLowerCase().includes('cpf'),
    );
    const titularIndex = excelHeaders.findIndex(h =>
      h.toLowerCase().includes('titular'),
    );

    // Pegue todos os CPFs dos erros
    const failedCpfs = resultadoUnificado.erros.map(item => item.cpf);

    // Filtra as linhas originais do excel que possuem CPF nos erros
    const failedRows = excelRawRows.filter(row =>
      failedCpfs.includes(row[cpfIndex]),
    );

    // Monta a planilha com header + linhas filtradas
    const ws = XLSX.utils.aoa_to_sheet([excelHeaders, ...failedRows]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Falhas');
    XLSX.writeFile(wb, 'linhas_falhadas.xlsx');
  };

  if (!formData) return;

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-green-600 mb-4">{message}</h2>
      {resultadoUnificado.data && resultadoUnificado.data.length > 0 && (
        <div>
          <button
            className="mb-4 px-4 py-2 bg-red-600 text-white rounded"
            onClick={downloadFailedRowsExcel}
          >
            Baixar Excel com erros
          </button>
          <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
            <thead className="bg-gray-200">
              <tr>
                <th className="p-2 text-left">Titular</th>
                <th className="p-2 text-left">Erro S4e</th>
              </tr>
            </thead>
            <tbody>
              {resultadoUnificado.data.map((item, index) => (
                <tr key={index} className="border-b hover:bg-gray-50">
                  <td className="p-2 font-medium">{item.titular}</td>
                  <td className="p-2 text-red-600">{item.error}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {resultadoUnificado.erros && resultadoUnificado.erros.length > 0 && (
        <>
          {!(resultadoUnificado.data && resultadoUnificado.data.length > 0) && (
            <button
              className="mb-4 px-4 py-2 bg-red-600 text-white rounded"
              onClick={downloadFailedRowsExcel}
            >
              Baixar Excel com erros
            </button>
          )}
          <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
            <thead className="bg-gray-200">
              <tr>
                <th className="p-2 text-left">Titular</th>
                <th className="p-2 text-left">Cpf</th>
                <th className="p-2 text-left">
                  Erro {resultadoUnificado.RetornoApis?.tipo}
                </th>
              </tr>
            </thead>
            <tbody>
              {resultadoUnificado.erros.map((item, index) => (
                <tr key={index} className="border-b hover:bg-gray-50">
                  <td className="p-2 font-medium">{item.titular}</td>
                  <td className="p-2 font-medium">{item.cpf}</td>
                  <td className="p-2 text-red-600">
                    {item.error ||
                      item.resultados.find(res => res.tipo === 'titular')
                        ?.resultado?.Result ||
                      'Erro desconhecido'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
